const DATASOURCEVIEW = {
  listOrigens: "Lista de origenes",
  uploadOrigin: "Cargar origen",
  conecctions: "Conexiones",
  origin: "Origen",
  description: "Descripción",
  company: "Compañia",
  process: "Proceso",
  numberRecords: "No. registros",
  state: "Estado",
  actions: "Acciones",
  emptyOrigins: "No hay origenes de datos registrados",
  listForms: "Lista de Formularios",
  deleteOrigin: "Eliminar Origen de Datos: {description}",
  messagge1: "Ésta opción no se puede deshacer, está seguro?",
  accept: "Aceptar",
  cancel: "Cancelar",
  titleDeleteOrigen: "Eliminar Origenes de datos",
  errorToDeleteOrigen: "Ocurrio un error, al eliminar el Origen de datos",
  originData: "Origenes de datos",
  actionNotAvailable: "Acción no disponible de momento",
  uploadFileOriginData: "Carga un archivo con información para el Origen de datos.",
  charactersSpecials:
    "Recuerda no utilizar <strong>caracteres especiales en las cabeceras, ni dejar espacios en blanco.</strong>",
  uploadmasive: "Cargue masivo",
  searchConnection: "Buscar conexión...",
  connections: "Conexiones",
  dataBase: "Base de datos",
  dataBaseNotHasTabe: "La base de datos no posee tablas.",
  Create: "Crear",
  originData: "Origen de datos",
  errorToCreateOrigin: "Error al crear el origen de datos.",
  successCreate: "Origen de datos creado",
  btnCreateOrigin: "Crear origen"
};

export default { DATASOURCEVIEW };
